const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteAlgoritmix = async (id_rebut : number , page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8073/algoritmix/${id_rebut}`, {
            method: 'DELETE',
            headers: {
                // No es necesario definir el encabezado 'content-type' aquí
                'pantalla': page,
            }
        });

        const jsonData = await response.json();
        return jsonData;

    } catch (error) {
        console.error('Error al cargar el archivo', error);
    }
};
